module.exports = __webpack_public_path__ + "img/insert.685da08b.svg";